module.exports = __webpack_public_path__ + "img/planting_05.df1e5db.webp";